import type { FeatureCode } from "@/features/system-admin/constants/features";
import { useOrgFeatures } from "./use-org-features";

export function useFeatureEnabled(code: FeatureCode): boolean {
  return useOrgFeatures().includes(code);
}
